exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.active {\r\n  color: black;\r\n  text-decoration: underline;\r\n}\r\n\r\n@media (max-width:514px) {\r\n  .img-mobile {\r\n    height: 180px;\r\n  }\r\n  .text-header {\r\n    font-size: 1rem;\r\n  }\r\n  .img-p-logo {\r\n    float: left;\r\n    width: 55px !important;\r\n  }\r\n  .btn-warning {\r\n    font-size: 0.7rem !important;\r\n  }\r\n  .text-name-product {\r\n    font-size: 0.8rem !important;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/rice-spacial/rice-spacial.component.css
// module id = ../../../../../src/app/components/rice-spacial/rice-spacial.component.css
// module chunks = main